(() => {
  'use strict';
  const purposes = ['analytics', 'marketing', 'preferences'];
  const version = '2026-10-21';
  let api;
  let previous = { analytics: false, marketing: false, preferences: false };
  let initialized = false;
  let submitted = false;
  let loadAttempts = 0;
  let lastFocus;
  let timeout;
  const banner = () => document.getElementById('cascas-cookie-banner');
  const modal = () => document.getElementById('cascas-cookie-preferences');
  const inputs = () => [...document.querySelectorAll('[data-cascas-cookie-category]')];
  const current = () => api.currentVisitorConsent();
  const explicit = () => {
    const consent = current();
    return {
      analytics: consent.analytics === 'yes' && api.analyticsProcessingAllowed(),
      marketing: consent.marketing === 'yes' && api.marketingAllowed(),
      preferences: consent.preferences === 'yes' && api.preferencesProcessingAllowed()
    };
  };
  const setBusy = value => {
    document.querySelectorAll('[data-cascas-cookie]:not([data-cascas-cookie="settings"]):not([data-cascas-cookie="close"])').forEach(button => { button.disabled = value; });
    if (banner()) banner().setAttribute('aria-busy', String(value));
    if (modal()) modal().setAttribute('aria-busy', String(value));
  };
  const showError = () => {
    clearTimeout(timeout);
    submitted = false;
    setBusy(false);
    if (banner()) banner().hidden = false;
    document.querySelectorAll('[data-cascas-cookie-error]').forEach(element => { element.hidden = false; });
  };
  function apply() {
    if (!api) return;
    const allowed = explicit();
    const metadata = document.documentElement;
    purposes.forEach(purpose => { metadata.dataset['cascasConsent' + purpose[0].toUpperCase() + purpose.slice(1)] = allowed[purpose] ? 'granted' : 'denied'; });
    metadata.dataset.cascasConsentReady = 'true';
    window.gtag('consent', 'update', {
      analytics_storage: allowed.analytics ? 'granted' : 'denied',
      ad_storage: allowed.marketing ? 'granted' : 'denied',
      ad_user_data: allowed.marketing ? 'granted' : 'denied',
      ad_personalization: allowed.marketing ? 'granted' : 'denied',
      functionality_storage: allowed.preferences ? 'granted' : 'denied',
      personalization_storage: allowed.preferences ? 'granted' : 'denied'
    });
    document.querySelectorAll('template[data-cascas-consent-purposes]').forEach(template => {
      const needed = template.dataset.cascasConsentPurposes.split(',');
      if (template.dataset.loaded || !needed.every(purpose => allowed[purpose])) return;
      template.dataset.loaded = 'true';
      const fragment = template.content.cloneNode(true);
      const scripts = [...fragment.querySelectorAll('script')];
      scripts.forEach(original => {
        const live = document.createElement('script');
        [...original.attributes].forEach(attribute => live.setAttribute(attribute.name, attribute.value));
        live.textContent = original.textContent;
        original.replaceWith(live);
      });
      template.after(fragment);
    });
    previous = allowed;
  }
  function sync() {
    if (!api || submitted) return;
    const next = explicit();
    const revoked = purposes.some(purpose => previous[purpose] && !next[purpose]);
    if (revoked) {
      if (typeof window.TriplePixel === 'function') window.TriplePixel('trackingConsent', false);
      purgeRevoked(previous, next);
      apply();
      location.reload();
      return;
    }
    apply();
  }
  function open() {
    if (!modal()) return;
    lastFocus = document.activeElement;
    const consent = api ? current() : {};
    inputs().forEach(input => { input.checked = consent[input.name] === 'yes'; });
    const receipt = document.querySelector('[data-cascas-cookie-receipt]');
    const id = api && typeof api.consentId === 'function' ? api.consentId() : '';
    if (receipt) {
      receipt.hidden = !id;
      receipt.querySelector('span').textContent = id || '';
    }
    modal().showModal();
  }
  function close() {
    if (modal()?.open) modal().close();
    if (lastFocus?.isConnected) lastFocus.focus({ preventScroll: true });
  }
  function purgeRevoked(old, next) {
    const patterns = [];
    if (old.analytics && !next.analytics) patterns.push(/^_ga(?:_|$)/, /^_gid$/, /^_gat/, /^TriplePixel/);
    if (old.marketing && !next.marketing) patterns.push(/^_fbp$/, /^_fbc$/, /^_gcl_/, /^__kla_id$/, /^_ttp$/, /^_pin_/, /^TriplePixel/);
    if (!patterns.length) return;
    const host = location.hostname.split('.');
    const domains = ['', ...host.slice(0, -1).map((_, index) => '.' + host.slice(index).join('.'))];
    const paths = ['/', ...location.pathname.split('/').slice(1).map((_, index, segments) => '/' + segments.slice(0, index + 1).join('/'))];
    document.cookie.split(';').forEach(pair => {
      const name = pair.split('=')[0].trim();
      if (!patterns.some(pattern => pattern.test(name))) return;
      domains.forEach(domain => paths.forEach(path => {
        document.cookie = name + '=; Max-Age=0; Path=' + path + '; SameSite=Lax; Secure' + (domain ? '; Domain=' + domain : '');
      }));
    });
    if ((old.marketing && !next.marketing) || (old.analytics && !next.analytics)) {
      try {
        Object.keys(localStorage).filter(key => /^TriplePixel/.test(key)).forEach(key => localStorage.removeItem(key));
        Object.keys(sessionStorage).filter(key => /^TriplePixel/.test(key)).forEach(key => sessionStorage.removeItem(key));
      } catch (error) {}
    }
  }
  function save(choice) {
    if (!api || submitted) { if (!api) showError(); return; }
    submitted = true;
    if (purposes.every(purpose => choice[purpose])) {
      if (banner()) banner().hidden = true;
      close();
    }
    setBusy(true);
    document.querySelectorAll('[data-cascas-cookie-error]').forEach(element => { element.hidden = true; });
    const old = { ...previous };
    const payload = { ...choice, metafields: [{ key: 'cascas_banner_version', value: version }] };
    timeout = setTimeout(showError, 10000);
    try {
      api.setTrackingConsent(payload, result => {
        clearTimeout(timeout);
        const actual = current();
        if (result?.error || !purposes.every(purpose => actual[purpose] === (choice[purpose] ? 'yes' : 'no'))) { showError(); return; }
        const revoked = purposes.some(purpose => old[purpose] && !choice[purpose]);
        if (revoked && typeof window.TriplePixel === 'function') window.TriplePixel('trackingConsent', false);
        purgeRevoked(old, choice);
        if (banner()) banner().hidden = true;
        close();
        apply();
        submitted = false;
        setBusy(false);
        if (revoked) location.reload();
      });
    } catch (error) { showError(); }
  }
  function start() {
    if (initialized) return;
    if (!window.Shopify?.loadFeatures) {
      if (++loadAttempts < 60) setTimeout(start, 100);
      else { if (banner()) banner().hidden = false; showError(); }
      return;
    }
    initialized = true;
    const apiTimeout = setTimeout(() => { if (!api) { if (banner()) banner().hidden = false; showError(); } }, 8000);
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
      clearTimeout(apiTimeout);
      if (error || !window.Shopify.customerPrivacy) { if (banner()) banner().hidden = false; showError(); return; }
      api = window.Shopify.customerPrivacy;
      apply();
      const consent = current();
      const noChoice = !purposes.every(purpose => consent[purpose] === 'yes' || consent[purpose] === 'no');
      if (banner()) banner().hidden = !(noChoice || new URLSearchParams(location.search).get('cascas_cookie_preview') === '1');
      document.addEventListener('visitorConsentCollected', sync);
      window.addEventListener('pageshow', event => { if (event.persisted) sync(); });
      document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') sync(); });
    });
  }
  document.addEventListener('click', event => {
    const action = event.target.closest('[data-cascas-cookie]')?.dataset.cascasCookie;
    if (!action) return;
    event.preventDefault();
    if (action === 'settings') open();
    if (action === 'close') close();
    if (action === 'accept' || action === 'reject') save(Object.fromEntries(purposes.map(purpose => [purpose, action === 'accept'])));
    if (action === 'save') save(Object.fromEntries(inputs().map(input => [input.name, input.checked])));
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

(() => {
  const key = Symbol.for('cascas.cookieScrollGuard');
  if (window[key]) return;

  const panel = () => {
    const dialog = document.getElementById('cascas-cookie-preferences');
    if (dialog && dialog.open) return dialog;
    const banner = document.getElementById('cascas-cookie-banner');
    return banner && !banner.hidden ? banner : null;
  };
  const canScroll = (target, surface, x, y) => {
    if (!surface.contains(target)) return false;
    const vertical = Math.abs(y) >= Math.abs(x);
    const amount = vertical ? y : x;
    if (!amount) return true;
    let node = target.nodeType === 1 ? target : target.parentElement;
    while (node) {
      const style = window.getComputedStyle(node);
      const overflow = vertical ? style.overflowY : style.overflowX;
      const size = vertical ? node.clientHeight : node.clientWidth;
      const extent = vertical ? node.scrollHeight : node.scrollWidth;
      const offset = vertical ? node.scrollTop : node.scrollLeft;
      if (/^(auto|scroll|overlay)$/.test(overflow) && extent > size + 1) {
        if (amount < 0 && offset > 0.5) return true;
        if (amount > 0 && offset + size < extent - 0.5) return true;
      }
      if (node === surface) break;
      node = node.parentElement;
    }
    return false;
  };
  const block = (event) => {
    if (event.cancelable) event.preventDefault();
  };
  let previousTouch = null;
  const touchStart = (event) => {
    previousTouch = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
  };
  const touchMove = (event) => {
    if (event.touches.length !== 1) {
      previousTouch = null;
      return;
    }
    const touch = event.touches[0];
    const previous = previousTouch;
    previousTouch = { x: touch.clientX, y: touch.clientY };
    const surface = panel();
    if (!surface) return;
    if (!previous || !canScroll(event.target, surface, previous.x - touch.clientX, previous.y - touch.clientY)) block(event);
  };
  const touchEnd = () => { previousTouch = null; };
  const wheel = (event) => {
    if (event.ctrlKey) return;
    const surface = panel();
    if (surface && !canScroll(event.target, surface, event.deltaX, event.deltaY)) block(event);
  };
  const capture = { capture: true, passive: false };
  const passive = { capture: true, passive: true };
  document.addEventListener('touchstart', touchStart, passive);
  document.addEventListener('touchmove', touchMove, capture);
  document.addEventListener('touchend', touchEnd, passive);
  document.addEventListener('touchcancel', touchEnd, passive);
  document.addEventListener('wheel', wheel, capture);
  window[key] = {
    dispose() {
      document.removeEventListener('touchstart', touchStart, passive);
      document.removeEventListener('touchmove', touchMove, capture);
      document.removeEventListener('touchend', touchEnd, passive);
      document.removeEventListener('touchcancel', touchEnd, passive);
      document.removeEventListener('wheel', wheel, capture);
      previousTouch = null;
      delete window[key];
    }
  };
})();


(() => {
  const key = Symbol.for('cascas.cookieInteractionGuard');
  if (window[key]) return;
  const roots = () => ['cascas-cookie-banner', 'cascas-cookie-preferences'].map(id => document.getElementById(id)).filter(Boolean);
  const panel = () => {
    const [banner, dialog] = ['cascas-cookie-banner', 'cascas-cookie-preferences'].map(id => document.getElementById(id));
    return dialog?.open ? dialog : banner && !banner.hidden ? banner : null;
  };
  const owned = new Set();
  let active = null;
  let previousFocus = null;
  let lastOutsideFocus = document.activeElement && document.activeElement !== document.body && !roots().some(root => root.contains(document.activeElement)) ? document.activeElement : null;
  let disposed = false;
  const controls = surface => [...surface.querySelectorAll('a[href], button, input, select, textarea, [tabindex]')]
    .filter(node => !node.matches(':disabled') && node.tabIndex >= 0 && !node.closest('[hidden]') && node.getClientRects().length);
  const focusPanel = surface => {
    if (surface && !surface.contains(document.activeElement)) controls(surface)[0]?.focus({ preventScroll: true });
  };
  const release = () => {
    owned.forEach(node => node.removeAttribute('inert'));
    owned.clear();
    if (previousFocus?.isConnected && !previousFocus.closest('[inert]') &&
      (document.activeElement === document.body || roots().some(root => root.contains(document.activeElement)))) {
      previousFocus.focus({ preventScroll: true });
    }
    previousFocus = null;
  };
  const sync = () => {
    if (disposed || !document.body) return;
    const surface = panel();
    if (!surface) { active = null; release(); return; }
    const consentRoots = roots();
    if (!active) {
      const focused = document.activeElement;
      previousFocus = focused && focused !== document.body && !consentRoots.some(root => root.contains(focused)) ? focused : lastOutsideFocus;
    }
    active = surface;
    const outside = new Set([...document.body.children].filter(node => !consentRoots.some(root => node === root || node.contains(root))));
    owned.forEach(node => {
      if (!outside.has(node)) { node.removeAttribute('inert'); owned.delete(node); }
    });
    outside.forEach(node => {
      if (!node.hasAttribute('inert')) { node.setAttribute('inert', ''); owned.add(node); }
    });
    focusPanel(surface);
  };
  const prevent = event => {
    if (event.cancelable) event.preventDefault();
    event.stopImmediatePropagation();
  };
  const outsideInput = event => {
    const surface = panel();
    if (surface && !surface.contains(event.target)) prevent(event);
  };
  const keydown = event => {
    if (event.ctrlKey || event.metaKey || event.altKey) return;
    const surface = panel();
    if (!surface) return;
    if (event.key === 'Tab') {
      const items = controls(surface);
      const index = items.indexOf(document.activeElement);
      if (index < 0 || (event.shiftKey ? index === 0 : index === items.length - 1)) {
        prevent(event);
        (event.shiftKey ? items[items.length - 1] : items[0])?.focus({ preventScroll: true });
      }
    } else if (!surface.contains(event.target)) prevent(event);
  };
  const focusin = event => {
    const surface = panel();
    if (!surface) {
      if (event.target !== document.body && !roots().some(root => root.contains(event.target))) lastOutsideFocus = event.target;
      return;
    }
    if (surface && !surface.contains(event.target)) {
      event.stopImmediatePropagation();
      focusPanel(surface);
    }
  };
  const rootObserver = new MutationObserver(sync);
  const watchRoots = () => {
    rootObserver.disconnect();
    roots().forEach(root => rootObserver.observe(root, { attributes: true, attributeFilter: ['hidden', 'open'] }));
    sync();
  };
  const bodyObserver = new MutationObserver(watchRoots);
  const pointerEvents = ['pointerdown', 'mousedown', 'touchstart', 'click', 'auxclick', 'dblclick', 'contextmenu'];
  const capture = { capture: true, passive: false };
  pointerEvents.forEach(event => window.addEventListener(event, outsideInput, capture));
  window.addEventListener('keydown', keydown, capture);
  window.addEventListener('focusin', focusin, true);
  window.addEventListener('pageshow', sync);
  const start = () => {
    if (disposed || !document.body) return;
    bodyObserver.observe(document.body, { childList: true });
    watchRoots();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window[key] = {
    dispose() {
      disposed = true;
      bodyObserver.disconnect();
      rootObserver.disconnect();
      document.removeEventListener('DOMContentLoaded', start);
      pointerEvents.forEach(event => window.removeEventListener(event, outsideInput, capture));
      window.removeEventListener('keydown', keydown, capture);
      window.removeEventListener('focusin', focusin, true);
      window.removeEventListener('pageshow', sync);
      active = null;
      release();
      delete window[key];
    }
  };
})();
